import { Tenant } from '../types/tenant';
import { getCurrentEnvironment } from './environment';

/**
 * Configuração dos tenants por ambiente
 */
const TENANTS_BY_ENVIRONMENT: Record<string, Tenant[]> = {
  development: [
    {
      id: 'substrato',
      name: 'Tenant DEV (Legado)',
      description: 'Ambiente de desenvolvimento legado',
      color: '#2196F3',
    },
    {
      id: 'cexp-dev',
      name: 'Tenant cexp-dev',
      description: 'Ambiente de teste para o time de Atendimento',
      color: '#FF5722',
    },
  ],
  production: [
    {
      id: 'substrato-example',
      name: 'Tenant Substrato',
      description: 'Ambiente de exemplo para o time de Substrato',
      color: '#4CAF50',
    },
    {
      id: 'cexp-main',
      name: 'Tenant Atendimento',
      description: 'Ambiente de produção para o time de Atendimento',
      color: '#FF9800',
    },
    {
      id: 'core-saida-prod',
      name: 'Tenant Contabilidade',
      description: 'Ambiente de produção para o time de Contabilidade.Tech',
      color: '#9C27B0',
    },
    {
      id: 'dados-cadastrais-prod',
      name: 'Tenant Dados Cadastrais',
      description: 'Ambiente de produção para o time de Contabilidade.Tech',
      color: '#607D8B',
    },
    {
      id: 'core-entrada-prod',
      name: 'Tenant Core Entrada',
      description: 'Ambiente de produção para o time de Contabilidade.Tech',
      color: '#E91E63',
    },
  ],
};

/**
 * Obtém os tenants disponíveis baseado no ambiente atual
 */
export const getAvailableTenants = (): Tenant[] => {
  const environment = getCurrentEnvironment();
  return TENANTS_BY_ENVIRONMENT[environment] || [];
};

/**
 * Configuração dos tenants disponíveis na aplicação
 *
 * Esta configuração define os tenants fixos que estarão disponíveis
 * para seleção pelos usuários, baseado no ambiente atual.
 * No futuro, esta lista pode ser carregada dinamicamente da API.
 */
export const AVAILABLE_TENANTS: Tenant[] = getAvailableTenants();

/**
 * Chave para armazenar o tenant selecionado no localStorage
 */
export const TENANT_STORAGE_KEY = 'orchestrator-console-selected-tenant';

/**
 * Função para obter um tenant por nome
 */
export const getTenantByName = (name: string): Tenant | undefined => {
  return AVAILABLE_TENANTS.find(tenant => tenant.name === name);
};

/**
 * Função para obter o tenant padrão (primeiro da lista)
 */
export const getDefaultTenant = (): Tenant | null => {
  return AVAILABLE_TENANTS.length > 0 ? AVAILABLE_TENANTS[0] : null;
};
